/**
 * usePrefetchTrainers — prefetch all 6 trainer types into React Query cache.
 * Call on hover over the "Тренажёры" nav link so data is ready before the click.
 * Uses the SAME query keys as TrainersPage so the cache is shared.
 */
import { useQueryClient } from '@tanstack/react-query';
import ExercisesAPI from '@/api/exercises.api';
import TreadmillsAPI from '@/api/treadmills.api';
import QuestionnairesAPI from '@/api/questionnaires.api';
import DrochkaAPI from '@/api/drochka.api';
import DialogsAPI from '@/api/dialogs.api';
import TestsAPI from '@/api/tests.api';
import { useAuthStore } from '@/stores/auth.store';

const STALE = 10 * 60 * 1000; // 10 min — matches TrainersPage

export function usePrefetchTrainers() {
  const queryClient = useQueryClient();
  const user = useAuthStore(s => s.user);

  return () => {
    if (!user?.id) return;

    queryClient.prefetchQuery({
      queryKey: ['trainersPage', 'exercises'],
      queryFn: () => ExercisesAPI.getByUser(user.id).catch(() => []),
      staleTime: STALE,
    });
    queryClient.prefetchQuery({
      queryKey: ['trainersPage', 'cards'],
      queryFn: () => DrochkaAPI.getAll().catch(() => []),
      staleTime: STALE,
    });
    queryClient.prefetchQuery({
      queryKey: ['trainersPage', 'treadmills'],
      queryFn: () => TreadmillsAPI.getLightUserList(user.id).catch(() => []),
      staleTime: STALE,
    });
    queryClient.prefetchQuery({
      queryKey: ['trainersPage', 'questionnaires'],
      queryFn: () => QuestionnairesAPI.getAll().catch(() => []),
      staleTime: STALE,
    });
    queryClient.prefetchQuery({
      queryKey: ['trainersPage', 'dialogs'],
      queryFn: () => DialogsAPI.getAllDialogs().catch(() => []),
      staleTime: STALE,
    });
    queryClient.prefetchQuery({
      queryKey: ['trainersPage', 'tests'],
      queryFn: () => TestsAPI.getAllTests().catch(() => []),
      staleTime: STALE,
    });
  };
}
